/**************************************************
 * Nombre:       Dialogo_Producto_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import {guardarRegistro} from "../../Modulo_Algolia/Funciones/guardarRegistro";
import Formulario_Producto_Informacion from "../Formularios/Formulario_Producto_Informacion";

const Dialogo_Producto_Informacion = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()

        iniciarCarga()


        let doxImg = await subirImagenHostingFile(entidad.imgGuia)
        entidad.imgGuia = doxImg.data
        nuevoAviso({aviso: 'Imagen subida'})


        let dox = await guardarDoc('productos', entidad)
        if (dox.res) {
            await guardarFecha()
            await guardarRegistro({obj: entidad, coleccion: 'productos', id: dox.data})
            terminar({aviso: 'Datos de producto subidos'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Producto_Informacion props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Producto_Informacion